const REF_AFF = "refAff";

export default REF_AFF;
